// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detalhe_styles_pageWrap__utXGk {
  padding: 24px;
}

.detalhe_styles_container__G\\+FUT {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.detalhe_styles_linkVoltar__SyYXz {
  display: inline-block;
  margin-bottom: 12px;
  font-size: 14px;
  color: #1e4a7a;
  font-weight: 600;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.detalhe_styles_pageHeader__rBecO {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

/* Aditivo, só usado no detalhe CAT-42 — alinha as ações pela base do bloco de título
   (mesma linha do badge), em vez do topo. */
.detalhe_styles_pageHeaderAcoesNaBase__iLh-X {
  align-items: flex-end;
}

/* Título/subtítulo encolhem e quebram texto internamente em vez de empurrar as ações
   pra uma linha nova — mantém os botões ancorados no topo à direita mesmo com título
   longo. */
.detalhe_styles_headerTitleBlock__ytYPE {
  flex: 1 1 auto;
  min-width: 0;
}

.detalhe_styles_pageTitle__BHpU1 {
  font-size: 26px;
  color: #0d2847;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}

.detalhe_styles_pageSubtitle__Wmc7e {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
  font-family: ui-monospace, monospace;
  line-height: 1.5;
}

.detalhe_styles_badgeTipo__vNmG- {
  display: inline-block;
  margin-top: 10px;
  margin-right: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: #e8f0f8;
  color: #1e4a7a;
}

.detalhe_styles_badgeGrupo__1YYM1 {
  display: inline-block;
  margin-top: 10px;
  margin-right: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: #e6f4ea;
  color: #1e7a3c;
}

.detalhe_styles_badgeSucesso__XP2wO {
  background: #e8f5e9;
  color: #2e7d32;
}

.detalhe_styles_headerActions__8X7kv {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.detalhe_styles_btnHeader__M5NAE {
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalhe_styles_btnHeaderPrimary__1Mdkd {
  background: #1e4a7a;
  color: #fff;
  border-color: #1e4a7a;
}

.detalhe_styles_btnHeader__M5NAE:hover {
  filter: brightness(1.05);
}

/* .btnHeader/.btnHeaderPrimary nunca tiveram estado :disabled — um botão desabilitado
 * (ex.: "Detalhes" da aba Contribuições, ainda sem tela de lançamentos — TXM-600) ficava
 * com a MESMA cor de um botão ativo, só bloqueando o clique via atributo HTML; visualmente
 * parecia clicável. Mesmos valores de .btnPage:disabled (opacity 0.45 + not-allowed), já
 * usado no mesmo arquivo, pra manter um único padrão de "desabilitado" na tela. */
.detalhe_styles_btnHeader__M5NAE:disabled,
.detalhe_styles_btnHeaderPrimary__1Mdkd:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.detalhe_styles_btnHeader__M5NAE:disabled:hover {
  filter: none;
}

.detalhe_styles_sectionListHeader__e9jEj {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.detalhe_styles_sectionTitle__4uRKT {
  font-size: 18px;
  font-weight: 600;
  color: #0d2847;
  margin: 0;
}

.detalhe_styles_toolbar__91RHS {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.detalhe_styles_toolbarHint__lU\\+4r {
  font-size: 13px;
  color: #666;
}

.detalhe_styles_btnExportar__31dQ7 {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.detalhe_styles_filtersSection__64ojV {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px 20px;
  margin-bottom: 25px;
}

.detalhe_styles_filtersHeader__E32ZY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.detalhe_styles_filtersHeaderExpanded__1\\+LUp {
  margin-bottom: 12px;
}

.detalhe_styles_filtersSectionCollapsed__JzKns {
  padding-bottom: 16px;
}

.detalhe_styles_filtersHeader__E32ZY .detalhe_styles_filtersTitle__oDMVp {
  margin-bottom: 0;
}

.detalhe_styles_filtersToggleIcon__spixi {
  font-size: 11px;
  color: #1e4a7a;
  transition: transform 0.2s ease;
  transform: rotate(-90deg);
  line-height: 1;
}

.detalhe_styles_filtersToggleIconOpen__XwJZ0 {
  transform: rotate(0deg);
}

.detalhe_styles_filtersBody__tvqF8 {
  padding-top: 4px;
}

.detalhe_styles_filtersTitle__oDMVp {
  font-size: 13px;
  font-weight: 600;
  color: #0d2847;
  margin-bottom: 12px;
}

.detalhe_styles_filtersRow__MRgpd {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  align-items: flex-end;
}

.detalhe_styles_filterGroup__IPRVg {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.detalhe_styles_filterLabel__F3ufQ {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.detalhe_styles_filterInput__LQHox,
.detalhe_styles_filterSelect__r8zOk {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  min-width: 180px;
  font-family: inherit;
  background: #fff;
}

.detalhe_styles_filterInput__LQHox[type="month"] {
  min-height: 38px;
}

.detalhe_styles_filterTwin__TA5zg {
  display: flex;
  align-items: center;
  gap: 10px;
}

.detalhe_styles_filterTwinSep__z7Rgu {
  font-size: 12px;
  color: #888;
}

.detalhe_styles_filtroMsDropdown__j5nzq {
  position: relative;
  min-width: 260px;
  max-width: 380px;
}

.detalhe_styles_filtroMsTrigger__LrECJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  cursor: pointer;
  text-align: left;
  color: #333;
}

.detalhe_styles_filtroMsTrigger__LrECJ:hover {
  border-color: #1e4a7a;
}

.detalhe_styles_filtroMsTriggerText__x7iAb {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.detalhe_styles_filtroMsChevron__gYD03 {
  font-size: 10px;
  color: #1e4a7a;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.detalhe_styles_filtroMsChevronOpen__yx3bF {
  transform: rotate(180deg);
}

.detalhe_styles_filtroMsPanel__DKRym {
  position: absolute;
  z-index: 20;
  top: calc(100% + 4px);
  left: 0;
  min-width: 360px;
  width: max(100%, 360px);
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 10px;
}

.detalhe_styles_filtroMsSearch__t6o-n {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
  margin-bottom: 8px;
}

.detalhe_styles_filtroMsActions__-Ne9K {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px 10px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.detalhe_styles_filtroMsActionBtn__0Z5Is {
  padding: 4px 2px;
  border: none;
  background: none;
  color: #1e4a7a;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  line-height: 1.2;
}

.detalhe_styles_filtroMsActionBtn__0Z5Is:hover:not(:disabled) {
  text-decoration: underline;
}

.detalhe_styles_filtroMsActionBtn__0Z5Is:disabled {
  color: #9aa8c3;
  cursor: not-allowed;
  text-decoration: none;
}

.detalhe_styles_filtroMsList__eo5lF {
  max-height: 220px;
  overflow-y: auto;
}

.detalhe_styles_filtroMsOption__fy9Eo {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 6px 4px;
  font-size: 13px;
  color: #444;
  cursor: pointer;
  border-radius: 4px;
}

.detalhe_styles_filtroMsOption__fy9Eo:hover {
  background: #f5f7fa;
}

.detalhe_styles_filtroMsOption__fy9Eo input {
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #1e4a7a;
}

.detalhe_styles_filtroMsOptionLabel__HJ5ra {
  line-height: 1.35;
  word-break: break-word;
  min-width: 0;
}

.detalhe_styles_filtroMsBadgeResultado__XRaJ1 {
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.45;
  letter-spacing: 0.01em;
  color: #1e4a7a;
  background: #e8eef5;
  border: 1px solid #c5d4e8;
  white-space: nowrap;
  vertical-align: middle;
}

.detalhe_styles_filtroMsEmpty__h-R1i {
  margin: 0;
  padding: 8px 4px;
  font-size: 13px;
  color: #888;
  text-align: center;
}

.detalhe_styles_tableWrap__oucMp {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 16px;
  scrollbar-width: auto;
}

.detalhe_styles_tableWrap__oucMp::-webkit-scrollbar,
.detalhe_styles_lancTableWrap__Gs5ah::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

.detalhe_styles_tableWrap__oucMp::-webkit-scrollbar-track,
.detalhe_styles_lancTableWrap__Gs5ah::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.detalhe_styles_tableWrap__oucMp::-webkit-scrollbar-thumb,
.detalhe_styles_lancTableWrap__Gs5ah::-webkit-scrollbar-thumb {
  background: rgba(24, 49, 110, 0.75);
  border-radius: 6px;
}

.detalhe_styles_tableWrap__oucMp::-webkit-scrollbar-thumb:hover,
.detalhe_styles_lancTableWrap__Gs5ah::-webkit-scrollbar-thumb:hover {
  background: rgba(24, 49, 110, 0.95);
}

.detalhe_styles_table__iq8v2 {
  width: 100%;
  border-collapse: collapse;
}

.detalhe_styles_table__iq8v2 thead {
  background: #f8f9fa;
}

.detalhe_styles_table__iq8v2 th {
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  color: #0d2847;
  border-bottom: 2px solid #e0e0e0;
  font-size: 13px;
  white-space: nowrap;
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_num__v739G {
  text-align: right;
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_sortable__FKuOb {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding-right: 22px;
  position: relative;
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_sortable__FKuOb:hover {
  background: #eef2f7;
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_sortedAsc__2X0WB::after,
.detalhe_styles_table__iq8v2 th.detalhe_styles_sortedDesc__qAHdh::after {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #1e4a7a;
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_sortedAsc__2X0WB::after {
  content: "▲";
}

.detalhe_styles_table__iq8v2 th.detalhe_styles_sortedDesc__qAHdh::after {
  content: "▼";
}

.detalhe_styles_table__iq8v2 td {
  padding: 15px 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #555;
}

.detalhe_styles_table__iq8v2 td.detalhe_styles_num__v739G {
  text-align: right;
  font-family: ui-monospace, monospace;
}

.detalhe_styles_selicRange__sBh21 {
  line-height: 1.4;
}

.detalhe_styles_selicMinMax__t6XIm {
  display: block;
  font-family: ui-monospace, monospace;
  font-size: 12px;
}

.detalhe_styles_selicRangeSep__gwd6m {
  color: #888;
  font-size: 11px;
}

.detalhe_styles_table__iq8v2 tbody tr:hover {
  background: #f8f9fa;
}

.detalhe_styles_contaHint__vo2ax {
  display: block;
  font-size: 11px;
  color: #888;
  margin-top: 4px;
}

.detalhe_styles_contaLabelRow__b2b99 {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.detalhe_styles_badgeContaResultado__wE9Nr {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #1e4a7a;
  background: #e8eef5;
  border: 1px solid #c5d4e8;
  white-space: nowrap;
}

.detalhe_styles_selFlag__ldKcn {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
}

/* Base legal: mesmo visual do .selFlag, com largura própria — as descrições são longas
   (artigo + lei), então precisa de espaço sem deixar a coluna explodir. */
.detalhe_styles_selBaseLegal__\\+G7ys {
  min-width: 180px;
  max-width: 280px;
}

.detalhe_styles_btnMini__X3l1R {
  padding: 8px 14px;
  border-radius: 6px;
  border: none;
  background: #1e4a7a;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalhe_styles_btnMini__X3l1R:hover {
  filter: brightness(1.06);
}

.detalhe_styles_emptyMsg__UtniT {
  text-align: center;
  padding: 24px;
  color: #888;
}

.detalhe_styles_paginationBar__ZQRA- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 8px;
}

.detalhe_styles_paginationInfo__67AIG {
  font-size: 13px;
  color: #555;
}

.detalhe_styles_paginationControls__Wt1EB {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.detalhe_styles_paginationControls__Wt1EB label {
  font-size: 13px;
  color: #555;
}

.detalhe_styles_pageSizeSelect__d0sc2 {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
}

.detalhe_styles_btnPage__FDCQf {
  padding: 8px 14px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.detalhe_styles_btnPage__FDCQf:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.detalhe_styles_dashGrid__QDn3I {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 18px;
  margin-bottom: 25px;
}

@media (max-width: 1100px) {
  .detalhe_styles_dashGrid__QDn3I {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .detalhe_styles_dashGrid__QDn3I {
    grid-template-columns: 1fr;
  }
}

.detalhe_styles_dashCard__ZuzP5 {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border-radius: 12px;
  padding: 16px 14px;
  border-left: 4px solid #1e4a7a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 0;
}

.detalhe_styles_dashCardAlerta__sehgC {
  grid-column: 1 / -1;
  border-left-color: #e65100;
  background: linear-gradient(135deg, #fff8e1 0%, #fff 100%);
}

.detalhe_styles_dashCardVazio__7KH\\+x {
  grid-column: 1 / -1;
  border-left-color: #888;
  background: linear-gradient(135deg, #f5f5f5 0%, #fff 100%);
}

/* TXM-418 — cards do detalhe CAT-42: cor por indicador (Ressarcimento/Complemento/
   Art. 271/estoque final), aditivo — não usado pelas outras telas de detalhe. */
.detalhe_styles_dashGrid4__fHXOF {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1100px) {
  .detalhe_styles_dashGrid4__fHXOF {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .detalhe_styles_dashGrid4__fHXOF {
    grid-template-columns: 1fr;
  }
}

.detalhe_styles_dashCardRessarcimento__\\+cG4j {
  border-left-color: #2e7d32;
}
.detalhe_styles_dashCardRessarcimento__\\+cG4j .detalhe_styles_dashLbl__9g6HR {
  color: #2e7d32;
}

.detalhe_styles_dashCardComplemento__YwYS- {
  border-left-color: #c62828;
}
.detalhe_styles_dashCardComplemento__YwYS- .detalhe_styles_dashLbl__9g6HR {
  color: #c62828;
}

.detalhe_styles_dashCardArt271__d\\+dYx {
  border-left-color: #7b1fa2;
}
.detalhe_styles_dashCardArt271__d\\+dYx .detalhe_styles_dashLbl__9g6HR {
  color: #7b1fa2;
}

.detalhe_styles_dashCardEstoque__j3CFg {
  border-left-color: #b8860b;
}
.detalhe_styles_dashCardEstoque__j3CFg .detalhe_styles_dashLbl__9g6HR {
  color: #b8860b;
}

.detalhe_styles_numRessarcimento__qx2Fe {
  color: #2e7d32;
}

.detalhe_styles_numComplemento__Slls\\+ {
  color: #c62828;
}

.detalhe_styles_dashAlertaTexto__WSL7s {
  margin: 10px 0 0;
  font-size: 13px;
  color: #555;
  line-height: 1.5;
}

.detalhe_styles_dashLbl__9g6HR {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.detalhe_styles_dashSub__wZkC0 {
  font-size: 11px;
  color: #888;
  margin-top: 4px;
  font-weight: 500;
}

.detalhe_styles_dashVal__vOvB3 {
  margin-top: 8px;
  font-weight: 700;
  color: #0d2847;
  font-family: ui-monospace, monospace;
  font-size: clamp(12px, 0.2rem + 1.15vw, 15px);
}

.detalhe_styles_yearStack__MXRrw {
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.detalhe_styles_yearLegend__jEDau {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 10px;
  font-size: 11px;
  color: #555;
}

.detalhe_styles_yearDot__XDioU {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: middle;
}

/* Seta de expandir/recolher a legenda quando passa de 3 linhas (mesmo padrão do eSocial). */
.detalhe_styles_yearLegendToggle__SJEjC {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 2px 0;
  border: none;
  background: none;
  color: #1f5fa8;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.detalhe_styles_yearLegendToggle__SJEjC:hover {
  text-decoration: underline;
}

.detalhe_styles_yearLegendToggleIcon__-eG1N {
  display: inline-block;
  font-size: 10px;
  transition: transform 0.15s ease;
}

.detalhe_styles_yearLegendToggleIconOpen__fumrz {
  transform: rotate(180deg);
}

.detalhe_styles_contaRef__\\+drsY {
  display: block;
  margin-top: 6px;
  font-weight: 600;
  color: #1e4a7a;
}

.detalhe_styles_lancTableWrap__Gs5ah {
  overflow-x: auto;
  margin-bottom: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  scrollbar-width: auto;
}

.detalhe_styles_lancTable__yCP9d {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  min-width: 1200px;
}

.detalhe_styles_lancTable__yCP9d th,
.detalhe_styles_lancTable__yCP9d td {
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
  white-space: nowrap;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.detalhe_styles_lancTable__yCP9d thead th {
  background: #f0f4f8;
  font-weight: 600;
  color: #0d2847;
  position: sticky;
  top: 0;
  z-index: 1;
}

.detalhe_styles_lancCellWrap__-R2bW {
  max-width: 100ch;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
}

.detalhe_styles_lancLoadingCell__jfRXP {
  text-align: center;
  color: #666;
  padding: 24px !important;
}

.detalhe_styles_mono__WyWp3 {
  font-family: ui-monospace, monospace;
  font-size: 11px;
}

.detalhe_styles_lancFiltrosWrap__ePzQg {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 20px;
}

.detalhe_styles_lancFiltrosRow__Nloxm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.detalhe_styles_lancFiltrosTitle__p-kT0 {
  font-size: 13px;
  font-weight: 600;
  color: #0d2847;
}

.detalhe_styles_lancFiltroSelect__hDU7Z {
  min-width: 220px;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 13px;
}

.detalhe_styles_btnFiltroAdd__B7dDi,
.detalhe_styles_btnFiltroLimpar__lxa7\\+ {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #1e4a7a;
  background: #fff;
  color: #1e4a7a;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.detalhe_styles_btnFiltroLimpar__lxa7\\+ {
  border-color: #ccc;
  color: #555;
}

.detalhe_styles_lancFiltrosAtivos__zo5-7 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detalhe_styles_lancFiltrosVazio__iOZvp {
  margin: 0;
  font-size: 13px;
  color: #777;
}

.detalhe_styles_lancFiltroAtivo__2ujb3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.detalhe_styles_lancFiltroLabel__guj\\+7 {
  font-size: 12px;
  font-weight: 600;
  color: #333;
  min-width: 160px;
}

.detalhe_styles_lancFiltroInput__SWD4q {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  min-width: 120px;
}

.detalhe_styles_lancFiltroRemove__cZ4pC {
  border: none;
  background: none;
  color: #c62828;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
}

.detalhe_styles_lancFiltrosAcoes__9mgEz {
  margin: -8px 0 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Apuracoes/Detalhe/detalhe.styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;4CAC4C;AAC5C;EACE,qBAAqB;AACvB;;AAEA;;WAEW;AACX;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;kFAIkF;AAClF;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;0EAC0E;AAC1E;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;gFACgF;AAChF;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,4FAA4F;AAC5F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".pageWrap {\n  padding: 24px;\n}\n\n.container {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n}\n\n.linkVoltar {\n  display: inline-block;\n  margin-bottom: 12px;\n  font-size: 14px;\n  color: #1e4a7a;\n  font-weight: 600;\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n}\n\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 25px;\n}\n\n/* Aditivo, só usado no detalhe CAT-42 — alinha as ações pela base do bloco de título\n   (mesma linha do badge), em vez do topo. */\n.pageHeaderAcoesNaBase {\n  align-items: flex-end;\n}\n\n/* Título/subtítulo encolhem e quebram texto internamente em vez de empurrar as ações\n   pra uma linha nova — mantém os botões ancorados no topo à direita mesmo com título\n   longo. */\n.headerTitleBlock {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.pageTitle {\n  font-size: 26px;\n  color: #0d2847;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.pageSubtitle {\n  font-size: 14px;\n  color: #666;\n  margin-top: 8px;\n  font-family: ui-monospace, monospace;\n  line-height: 1.5;\n}\n\n.badgeTipo {\n  display: inline-block;\n  margin-top: 10px;\n  margin-right: 8px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #e8f0f8;\n  color: #1e4a7a;\n}\n\n.badgeGrupo {\n  display: inline-block;\n  margin-top: 10px;\n  margin-right: 8px;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #e6f4ea;\n  color: #1e7a3c;\n}\n\n.badgeSucesso {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.headerActions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.btnHeader {\n  padding: 10px 16px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnHeaderPrimary {\n  background: #1e4a7a;\n  color: #fff;\n  border-color: #1e4a7a;\n}\n\n.btnHeader:hover {\n  filter: brightness(1.05);\n}\n\n/* .btnHeader/.btnHeaderPrimary nunca tiveram estado :disabled — um botão desabilitado\n * (ex.: \"Detalhes\" da aba Contribuições, ainda sem tela de lançamentos — TXM-600) ficava\n * com a MESMA cor de um botão ativo, só bloqueando o clique via atributo HTML; visualmente\n * parecia clicável. Mesmos valores de .btnPage:disabled (opacity 0.45 + not-allowed), já\n * usado no mesmo arquivo, pra manter um único padrão de \"desabilitado\" na tela. */\n.btnHeader:disabled,\n.btnHeaderPrimary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.btnHeader:disabled:hover {\n  filter: none;\n}\n\n.sectionListHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0d2847;\n  margin: 0;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.toolbarHint {\n  font-size: 13px;\n  color: #666;\n}\n\n.btnExportar {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.filtersSection {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px 20px 20px;\n  margin-bottom: 25px;\n}\n\n.filtersHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.filtersHeaderExpanded {\n  margin-bottom: 12px;\n}\n\n.filtersSectionCollapsed {\n  padding-bottom: 16px;\n}\n\n.filtersHeader .filtersTitle {\n  margin-bottom: 0;\n}\n\n.filtersToggleIcon {\n  font-size: 11px;\n  color: #1e4a7a;\n  transition: transform 0.2s ease;\n  transform: rotate(-90deg);\n  line-height: 1;\n}\n\n.filtersToggleIconOpen {\n  transform: rotate(0deg);\n}\n\n.filtersBody {\n  padding-top: 4px;\n}\n\n.filtersTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0d2847;\n  margin-bottom: 12px;\n}\n\n.filtersRow {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filterLabel {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n}\n\n.filterInput,\n.filterSelect {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 180px;\n  font-family: inherit;\n  background: #fff;\n}\n\n.filterInput[type=\"month\"] {\n  min-height: 38px;\n}\n\n.filterTwin {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filterTwinSep {\n  font-size: 12px;\n  color: #888;\n}\n\n.filtroMsDropdown {\n  position: relative;\n  min-width: 260px;\n  max-width: 380px;\n}\n\n.filtroMsTrigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  color: #333;\n}\n\n.filtroMsTrigger:hover {\n  border-color: #1e4a7a;\n}\n\n.filtroMsTriggerText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.filtroMsChevron {\n  font-size: 10px;\n  color: #1e4a7a;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.filtroMsChevronOpen {\n  transform: rotate(180deg);\n}\n\n.filtroMsPanel {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 360px;\n  width: max(100%, 360px);\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  padding: 10px;\n}\n\n.filtroMsSearch {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  font-family: inherit;\n  margin-bottom: 8px;\n}\n\n.filtroMsActions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 4px 10px;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.filtroMsActionBtn {\n  padding: 4px 2px;\n  border: none;\n  background: none;\n  color: #1e4a7a;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.filtroMsActionBtn:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.filtroMsActionBtn:disabled {\n  color: #9aa8c3;\n  cursor: not-allowed;\n  text-decoration: none;\n}\n\n.filtroMsList {\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.filtroMsOption {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 6px 4px;\n  font-size: 13px;\n  color: #444;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.filtroMsOption:hover {\n  background: #f5f7fa;\n}\n\n.filtroMsOption input {\n  margin-top: 2px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #1e4a7a;\n}\n\n.filtroMsOptionLabel {\n  line-height: 1.35;\n  word-break: break-word;\n  min-width: 0;\n}\n\n.filtroMsBadgeResultado {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 0 5px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.45;\n  letter-spacing: 0.01em;\n  color: #1e4a7a;\n  background: #e8eef5;\n  border: 1px solid #c5d4e8;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.filtroMsEmpty {\n  margin: 0;\n  padding: 8px 4px;\n  font-size: 13px;\n  color: #888;\n  text-align: center;\n}\n\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  margin-bottom: 16px;\n  scrollbar-width: auto;\n}\n\n.tableWrap::-webkit-scrollbar,\n.lancTableWrap::-webkit-scrollbar {\n  height: 12px;\n  width: 12px;\n}\n\n.tableWrap::-webkit-scrollbar-track,\n.lancTableWrap::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 6px;\n}\n\n.tableWrap::-webkit-scrollbar-thumb,\n.lancTableWrap::-webkit-scrollbar-thumb {\n  background: rgba(24, 49, 110, 0.75);\n  border-radius: 6px;\n}\n\n.tableWrap::-webkit-scrollbar-thumb:hover,\n.lancTableWrap::-webkit-scrollbar-thumb:hover {\n  background: rgba(24, 49, 110, 0.95);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table thead {\n  background: #f8f9fa;\n}\n\n.table th {\n  padding: 15px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #0d2847;\n  border-bottom: 2px solid #e0e0e0;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.table th.num {\n  text-align: right;\n}\n\n.table th.sortable {\n  cursor: pointer;\n  user-select: none;\n  padding-right: 22px;\n  position: relative;\n}\n\n.table th.sortable:hover {\n  background: #eef2f7;\n}\n\n.table th.sortedAsc::after,\n.table th.sortedDesc::after {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 10px;\n  color: #1e4a7a;\n}\n\n.table th.sortedAsc::after {\n  content: \"▲\";\n}\n\n.table th.sortedDesc::after {\n  content: \"▼\";\n}\n\n.table td {\n  padding: 15px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n  color: #555;\n}\n\n.table td.num {\n  text-align: right;\n  font-family: ui-monospace, monospace;\n}\n\n.selicRange {\n  line-height: 1.4;\n}\n\n.selicMinMax {\n  display: block;\n  font-family: ui-monospace, monospace;\n  font-size: 12px;\n}\n\n.selicRangeSep {\n  color: #888;\n  font-size: 11px;\n}\n\n.table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.contaHint {\n  display: block;\n  font-size: 11px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.contaLabelRow {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.badgeContaResultado {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: #1e4a7a;\n  background: #e8eef5;\n  border: 1px solid #c5d4e8;\n  white-space: nowrap;\n}\n\n.selFlag {\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n  background: #fff;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n/* Base legal: mesmo visual do .selFlag, com largura própria — as descrições são longas\n   (artigo + lei), então precisa de espaço sem deixar a coluna explodir. */\n.selBaseLegal {\n  composes: selFlag;\n  min-width: 180px;\n  max-width: 280px;\n}\n\n.btnMini {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #1e4a7a;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnMini:hover {\n  filter: brightness(1.06);\n}\n\n.emptyMsg {\n  text-align: center;\n  padding: 24px;\n  color: #888;\n}\n\n.paginationBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding-top: 8px;\n}\n\n.paginationInfo {\n  font-size: 13px;\n  color: #555;\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.paginationControls label {\n  font-size: 13px;\n  color: #555;\n}\n\n.pageSizeSelect {\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.btnPage {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.btnPage:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.dashGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px 18px;\n  margin-bottom: 25px;\n}\n\n@media (max-width: 1100px) {\n  .dashGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .dashGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dashCard {\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n  border-radius: 12px;\n  padding: 16px 14px;\n  border-left: 4px solid #1e4a7a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  min-width: 0;\n}\n\n.dashCardAlerta {\n  grid-column: 1 / -1;\n  border-left-color: #e65100;\n  background: linear-gradient(135deg, #fff8e1 0%, #fff 100%);\n}\n\n.dashCardVazio {\n  grid-column: 1 / -1;\n  border-left-color: #888;\n  background: linear-gradient(135deg, #f5f5f5 0%, #fff 100%);\n}\n\n/* TXM-418 — cards do detalhe CAT-42: cor por indicador (Ressarcimento/Complemento/\n   Art. 271/estoque final), aditivo — não usado pelas outras telas de detalhe. */\n.dashGrid4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media (max-width: 1100px) {\n  .dashGrid4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .dashGrid4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dashCardRessarcimento {\n  border-left-color: #2e7d32;\n}\n.dashCardRessarcimento .dashLbl {\n  color: #2e7d32;\n}\n\n.dashCardComplemento {\n  border-left-color: #c62828;\n}\n.dashCardComplemento .dashLbl {\n  color: #c62828;\n}\n\n.dashCardArt271 {\n  border-left-color: #7b1fa2;\n}\n.dashCardArt271 .dashLbl {\n  color: #7b1fa2;\n}\n\n.dashCardEstoque {\n  border-left-color: #b8860b;\n}\n.dashCardEstoque .dashLbl {\n  color: #b8860b;\n}\n\n.numRessarcimento {\n  color: #2e7d32;\n}\n\n.numComplemento {\n  color: #c62828;\n}\n\n.dashAlertaTexto {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #555;\n  line-height: 1.5;\n}\n\n.dashLbl {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.dashSub {\n  font-size: 11px;\n  color: #888;\n  margin-top: 4px;\n  font-weight: 500;\n}\n\n.dashVal {\n  margin-top: 8px;\n  font-weight: 700;\n  color: #0d2847;\n  font-family: ui-monospace, monospace;\n  font-size: clamp(12px, 0.2rem + 1.15vw, 15px);\n}\n\n.yearStack {\n  display: flex;\n  height: 10px;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-top: 12px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.yearLegend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-top: 10px;\n  font-size: 11px;\n  color: #555;\n}\n\n.yearDot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n/* Seta de expandir/recolher a legenda quando passa de 3 linhas (mesmo padrão do eSocial). */\n.yearLegendToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  padding: 2px 0;\n  border: none;\n  background: none;\n  color: #1f5fa8;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.yearLegendToggle:hover {\n  text-decoration: underline;\n}\n\n.yearLegendToggleIcon {\n  display: inline-block;\n  font-size: 10px;\n  transition: transform 0.15s ease;\n}\n\n.yearLegendToggleIconOpen {\n  transform: rotate(180deg);\n}\n\n.contaRef {\n  display: block;\n  margin-top: 6px;\n  font-weight: 600;\n  color: #1e4a7a;\n}\n\n.lancTableWrap {\n  overflow-x: auto;\n  margin-bottom: 16px;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  scrollbar-width: auto;\n}\n\n.lancTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  min-width: 1200px;\n}\n\n.lancTable th,\n.lancTable td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #eee;\n  text-align: left;\n  white-space: nowrap;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lancTable thead th {\n  background: #f0f4f8;\n  font-weight: 600;\n  color: #0d2847;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.lancCellWrap {\n  max-width: 100ch;\n  white-space: normal;\n  word-break: break-word;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.lancLoadingCell {\n  text-align: center;\n  color: #666;\n  padding: 24px !important;\n}\n\n.mono {\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n}\n\n.lancFiltrosWrap {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 20px;\n}\n\n.lancFiltrosRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.lancFiltrosTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0d2847;\n}\n\n.lancFiltroSelect {\n  min-width: 220px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 13px;\n}\n\n.btnFiltroAdd,\n.btnFiltroLimpar {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #1e4a7a;\n  background: #fff;\n  color: #1e4a7a;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btnFiltroLimpar {\n  border-color: #ccc;\n  color: #555;\n}\n\n.lancFiltrosAtivos {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lancFiltrosVazio {\n  margin: 0;\n  font-size: 13px;\n  color: #777;\n}\n\n.lancFiltroAtivo {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.lancFiltroLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n  min-width: 160px;\n}\n\n.lancFiltroInput {\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 13px;\n  min-width: 120px;\n}\n\n.lancFiltroRemove {\n  border: none;\n  background: none;\n  color: #c62828;\n  font-size: 18px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0 4px;\n}\n\n.lancFiltrosAcoes {\n  margin: -8px 0 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `detalhe_styles_pageWrap__utXGk`,
	"container": `detalhe_styles_container__G+FUT`,
	"linkVoltar": `detalhe_styles_linkVoltar__SyYXz`,
	"pageHeader": `detalhe_styles_pageHeader__rBecO`,
	"pageHeaderAcoesNaBase": `detalhe_styles_pageHeaderAcoesNaBase__iLh-X`,
	"headerTitleBlock": `detalhe_styles_headerTitleBlock__ytYPE`,
	"pageTitle": `detalhe_styles_pageTitle__BHpU1`,
	"pageSubtitle": `detalhe_styles_pageSubtitle__Wmc7e`,
	"badgeTipo": `detalhe_styles_badgeTipo__vNmG-`,
	"badgeGrupo": `detalhe_styles_badgeGrupo__1YYM1`,
	"badgeSucesso": `detalhe_styles_badgeSucesso__XP2wO`,
	"headerActions": `detalhe_styles_headerActions__8X7kv`,
	"btnHeader": `detalhe_styles_btnHeader__M5NAE`,
	"btnHeaderPrimary": `detalhe_styles_btnHeaderPrimary__1Mdkd`,
	"sectionListHeader": `detalhe_styles_sectionListHeader__e9jEj`,
	"sectionTitle": `detalhe_styles_sectionTitle__4uRKT`,
	"toolbar": `detalhe_styles_toolbar__91RHS`,
	"toolbarHint": `detalhe_styles_toolbarHint__lU+4r`,
	"btnExportar": `detalhe_styles_btnExportar__31dQ7`,
	"filtersSection": `detalhe_styles_filtersSection__64ojV`,
	"filtersHeader": `detalhe_styles_filtersHeader__E32ZY`,
	"filtersHeaderExpanded": `detalhe_styles_filtersHeaderExpanded__1+LUp`,
	"filtersSectionCollapsed": `detalhe_styles_filtersSectionCollapsed__JzKns`,
	"filtersTitle": `detalhe_styles_filtersTitle__oDMVp`,
	"filtersToggleIcon": `detalhe_styles_filtersToggleIcon__spixi`,
	"filtersToggleIconOpen": `detalhe_styles_filtersToggleIconOpen__XwJZ0`,
	"filtersBody": `detalhe_styles_filtersBody__tvqF8`,
	"filtersRow": `detalhe_styles_filtersRow__MRgpd`,
	"filterGroup": `detalhe_styles_filterGroup__IPRVg`,
	"filterLabel": `detalhe_styles_filterLabel__F3ufQ`,
	"filterInput": `detalhe_styles_filterInput__LQHox`,
	"filterSelect": `detalhe_styles_filterSelect__r8zOk`,
	"filterTwin": `detalhe_styles_filterTwin__TA5zg`,
	"filterTwinSep": `detalhe_styles_filterTwinSep__z7Rgu`,
	"filtroMsDropdown": `detalhe_styles_filtroMsDropdown__j5nzq`,
	"filtroMsTrigger": `detalhe_styles_filtroMsTrigger__LrECJ`,
	"filtroMsTriggerText": `detalhe_styles_filtroMsTriggerText__x7iAb`,
	"filtroMsChevron": `detalhe_styles_filtroMsChevron__gYD03`,
	"filtroMsChevronOpen": `detalhe_styles_filtroMsChevronOpen__yx3bF`,
	"filtroMsPanel": `detalhe_styles_filtroMsPanel__DKRym`,
	"filtroMsSearch": `detalhe_styles_filtroMsSearch__t6o-n`,
	"filtroMsActions": `detalhe_styles_filtroMsActions__-Ne9K`,
	"filtroMsActionBtn": `detalhe_styles_filtroMsActionBtn__0Z5Is`,
	"filtroMsList": `detalhe_styles_filtroMsList__eo5lF`,
	"filtroMsOption": `detalhe_styles_filtroMsOption__fy9Eo`,
	"filtroMsOptionLabel": `detalhe_styles_filtroMsOptionLabel__HJ5ra`,
	"filtroMsBadgeResultado": `detalhe_styles_filtroMsBadgeResultado__XRaJ1`,
	"filtroMsEmpty": `detalhe_styles_filtroMsEmpty__h-R1i`,
	"tableWrap": `detalhe_styles_tableWrap__oucMp`,
	"lancTableWrap": `detalhe_styles_lancTableWrap__Gs5ah`,
	"table": `detalhe_styles_table__iq8v2`,
	"num": `detalhe_styles_num__v739G`,
	"sortable": `detalhe_styles_sortable__FKuOb`,
	"sortedAsc": `detalhe_styles_sortedAsc__2X0WB`,
	"sortedDesc": `detalhe_styles_sortedDesc__qAHdh`,
	"selicRange": `detalhe_styles_selicRange__sBh21`,
	"selicMinMax": `detalhe_styles_selicMinMax__t6XIm`,
	"selicRangeSep": `detalhe_styles_selicRangeSep__gwd6m`,
	"contaHint": `detalhe_styles_contaHint__vo2ax`,
	"contaLabelRow": `detalhe_styles_contaLabelRow__b2b99`,
	"badgeContaResultado": `detalhe_styles_badgeContaResultado__wE9Nr`,
	"selFlag": `detalhe_styles_selFlag__ldKcn`,
	"selBaseLegal": `detalhe_styles_selBaseLegal__+G7ys detalhe_styles_selFlag__ldKcn`,
	"btnMini": `detalhe_styles_btnMini__X3l1R`,
	"emptyMsg": `detalhe_styles_emptyMsg__UtniT`,
	"paginationBar": `detalhe_styles_paginationBar__ZQRA-`,
	"paginationInfo": `detalhe_styles_paginationInfo__67AIG`,
	"paginationControls": `detalhe_styles_paginationControls__Wt1EB`,
	"pageSizeSelect": `detalhe_styles_pageSizeSelect__d0sc2`,
	"btnPage": `detalhe_styles_btnPage__FDCQf`,
	"dashGrid": `detalhe_styles_dashGrid__QDn3I`,
	"dashCard": `detalhe_styles_dashCard__ZuzP5`,
	"dashCardAlerta": `detalhe_styles_dashCardAlerta__sehgC`,
	"dashCardVazio": `detalhe_styles_dashCardVazio__7KH+x`,
	"dashGrid4": `detalhe_styles_dashGrid4__fHXOF`,
	"dashCardRessarcimento": `detalhe_styles_dashCardRessarcimento__+cG4j`,
	"dashLbl": `detalhe_styles_dashLbl__9g6HR`,
	"dashCardComplemento": `detalhe_styles_dashCardComplemento__YwYS-`,
	"dashCardArt271": `detalhe_styles_dashCardArt271__d+dYx`,
	"dashCardEstoque": `detalhe_styles_dashCardEstoque__j3CFg`,
	"numRessarcimento": `detalhe_styles_numRessarcimento__qx2Fe`,
	"numComplemento": `detalhe_styles_numComplemento__Slls+`,
	"dashAlertaTexto": `detalhe_styles_dashAlertaTexto__WSL7s`,
	"dashSub": `detalhe_styles_dashSub__wZkC0`,
	"dashVal": `detalhe_styles_dashVal__vOvB3`,
	"yearStack": `detalhe_styles_yearStack__MXRrw`,
	"yearLegend": `detalhe_styles_yearLegend__jEDau`,
	"yearDot": `detalhe_styles_yearDot__XDioU`,
	"yearLegendToggle": `detalhe_styles_yearLegendToggle__SJEjC`,
	"yearLegendToggleIcon": `detalhe_styles_yearLegendToggleIcon__-eG1N`,
	"yearLegendToggleIconOpen": `detalhe_styles_yearLegendToggleIconOpen__fumrz`,
	"contaRef": `detalhe_styles_contaRef__+drsY`,
	"lancTable": `detalhe_styles_lancTable__yCP9d`,
	"lancCellWrap": `detalhe_styles_lancCellWrap__-R2bW`,
	"lancLoadingCell": `detalhe_styles_lancLoadingCell__jfRXP`,
	"mono": `detalhe_styles_mono__WyWp3`,
	"lancFiltrosWrap": `detalhe_styles_lancFiltrosWrap__ePzQg`,
	"lancFiltrosRow": `detalhe_styles_lancFiltrosRow__Nloxm`,
	"lancFiltrosTitle": `detalhe_styles_lancFiltrosTitle__p-kT0`,
	"lancFiltroSelect": `detalhe_styles_lancFiltroSelect__hDU7Z`,
	"btnFiltroAdd": `detalhe_styles_btnFiltroAdd__B7dDi`,
	"btnFiltroLimpar": `detalhe_styles_btnFiltroLimpar__lxa7+`,
	"lancFiltrosAtivos": `detalhe_styles_lancFiltrosAtivos__zo5-7`,
	"lancFiltrosVazio": `detalhe_styles_lancFiltrosVazio__iOZvp`,
	"lancFiltroAtivo": `detalhe_styles_lancFiltroAtivo__2ujb3`,
	"lancFiltroLabel": `detalhe_styles_lancFiltroLabel__guj+7`,
	"lancFiltroInput": `detalhe_styles_lancFiltroInput__SWD4q`,
	"lancFiltroRemove": `detalhe_styles_lancFiltroRemove__cZ4pC`,
	"lancFiltrosAcoes": `detalhe_styles_lancFiltrosAcoes__9mgEz`
};
export default ___CSS_LOADER_EXPORT___;
